import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import MiniTable from '../../../../components/mini-table';
import { compareStrings } from '../../../../util/string';
import { Button } from "antd";
import TableCellColor from "../../../../components/table-cell-color";

export default function ConsultivoAreaAssuntosTable({ dataSource, loading, miniTableRef, onClick, onSelectedIdsChange, selectedIds, title }) {
  const { t } = useTranslation();

  const fireClick = tipoTrabalho => typeof onClick === 'function' ? onClick(tipoTrabalho) : undefined;

  const columns = [
    {
      title: t('Descricao'),
      dataIndex: 'descricao',
      key: 'descricao',
      sorter: (a, b) => compareStrings(a.descricao, b.descricao),
      render: (text, record) => (
        <Button type="link" onClick={() => fireClick(record)}>
          {text ?? t('(não preenchido)')}
        </Button>
      ),
    },
    {
      title: t('Cor'),
      dataIndex: 'cor',
      key: 'cor',
      sorter: (a, b) => compareStrings(a.cor, b.cor),
      render: (text) => <TableCellColor text={text}/>,
    }
  ];

  return (
    <MiniTable
      ref={miniTableRef}
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      title={title}
      rowSelection={{
        selectedRowKeys: selectedIds,
        onChange: onSelectedIdsChange,
      }}
    />
  );
}

ConsultivoAreaAssuntosTable.propTypes = {
  dataSource: PropTypes.array,
  loading: PropTypes.bool,
  miniTableRef: PropTypes.object,
  onClick: PropTypes.func,
  onSelectedIdsChange: PropTypes.func,
  selectedIds: PropTypes.arrayOf(PropTypes.number),
  title: PropTypes.func,
};
